import { useEffect, useRef, useState } from 'react';

/**
 * Countdown shared by every timed quiz surface (ROO-180). Mirrors the
 * original TestTaking semantics: ticks once a second, fires onExpire exactly
 * once when reaching zero, and is inert until start() seeds a duration.
 */
export function useCountdown(onExpire: () => void) {
  const [timeLeft, setTimeLeft] = useState(0);
  const expireRef = useRef(onExpire);
  useEffect(() => { expireRef.current = onExpire; });

  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          expireRef.current();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);

  return { timeLeft, start: setTimeLeft };
}
